<i18n>
{
  "fr": {
    "configuratorGlassSettingsColorsRow": {
      "label": "Couleur\u00a0:"
    }
  }
}
</i18n>

<template>
  <div class="configurator-glass-settings-colors-row">
    <span class="configurator-glass-settings-colors-row__label">
      {{ $t('configuratorGlassSettingsColorsRow.label') }}
    </span>

    <div class="configurator-glass-settings-colors-row__wrapper">
      <div
        v-for="color of colors"
        :key="color.id"
        class="configurator-glass-settings-colors-row__color-wrapper"
      >
        <input
          :id="getOptionId(color)"
          type="radio"
          name="color"
          :value="color.id"
          :checked="activeColorId === color.id"
          class="configurator-glass-settings-colors-row__input option-picker__input"
          @change="onChange"
        />
        <label
          :for="getOptionId(color)"
          class="configurator-glass-settings-colors-row__color-label option-picker__label"
        >
          <ConfiguratorColoredDot
            :active="color === activeColor"
            :color="color.previewValue || color.value"
            :title="color.name"
            variant
            class="configurator-glass-settings-colors-row__color-dot configurator-glass-settings-colors-row__target-color-dot option-picker__colored-dot"
          />

          <span
            class="configurator-glass-settings-colors-row__color-name"
            v-text="color.name"
          ></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ConfiguratorAction,
  ConfiguratorGetters,
  mapGetters as mapConfiguratorGetters,
  prefixType as prefixConfiguratorType,
} from '../../../store/modules/configurator';
import ConfiguratorColoredDot from '../ConfiguratorColoredDot';

export default {
  name: 'ConfiguratorGlassSettingsColorsRow',
  components: { ConfiguratorColoredDot },
  computed: {
    ...mapConfiguratorGetters({
      colors: ConfiguratorGetters.GET_AVAILABLE_COLORS,
    }),
    activeColorId: {
      get() {
        return this.$store.state.configurator.activeColorId;
      },
      set(colorId) {
        this.$store.dispatch(
          prefixConfiguratorType(ConfiguratorAction.SET_ACTIVE_STATE),
          { colorId, fallbackWhenNotFound: false }
        );
      },
    },
    ...mapConfiguratorGetters({
      activeColor: ConfiguratorGetters.GET_ACTIVE_COLOR,
    }),
  },
  methods: {
    getOptionId(color) {
      return `configurator-glass-settings-colors-row__color--${color.name}--${color.id}`;
    },
    onChange(e) {
      this.activeColorId = Number.parseInt(e.target.value, 10);
    },
  },
};
</script>

<style scoped lang="scss">
.configurator-glass-settings-colors-row {
  @extend %configurator-section;

  display: flex;
  align-items: center;
  border-bottom: none;
  padding: $configurator-personalization-section-padding;

  &__label {
    margin-right: 1em;
  }

  &__color-dot {
    margin-bottom: 0.25em;
    font-size: 1.25rem;
  }

  &__color-name {
    font-weight: 600;
    font-size: 1rem;
    color: $color-primary;
    text-transform: capitalize;
  }

  &__wrapper {
    display: flex;
    flex-wrap: wrap;

    @include breakpoint($breakpoint-configurator-l) {
      font-size: 1.2em;
    }
  }

  &__color-label {
    display: flex;
    align-items: center;

    @include on-event() {
      &::v-deep {
        .configurator-colored-dot {
          &:before {
            border-color: $color-gray-silver;
          }
        }

        .configurator-colored-dot--active {
          &::before {
            border-color: $color-secondary;
          }
        }
      }
    }
  }

  &__color-wrapper {
    margin-right: 1em;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
